import { Lock, Wrench } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const PlanRemediere = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-slate-200 text-slate-600 px-3 py-1 rounded-full mb-4">
            <Lock className="w-4 h-4" />
            <span className="text-sm font-medium">Blocat</span>
          </div>
          <h1 className="text-3xl font-bold mb-4">Plan Remediere</h1>
          <p className="text-lg text-muted-foreground">
            Acțiuni corective pentru conformitate NIS2
          </p>
        </div>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-slate-200 flex items-center justify-center">
                <Wrench className="w-6 h-6 text-slate-500" />
              </div>
              <div>
                <CardTitle>Plan de Remediere</CardTitle>
                <CardDescription>
                  Acțiuni pentru atingerea conformității
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="bg-slate-50 rounded-lg p-6 text-center">
              <Lock className="w-12 h-12 text-slate-400 mx-auto mb-4" />
              <h3 className="font-semibold text-slate-700 mb-2">
                Modul blocat
              </h3>
              <p className="text-sm text-slate-500 max-w-md mx-auto">
                Planul de remediere devine disponibil după finalizarea evaluării
                de maturitate. Acesta va conține recomandări specifice pentru
                îmbunătățirea posturii de securitate cibernetică.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PlanRemediere;
